/**
 * @ngdoc component
 * @name common.component:itxContactForm
 * @description
 * A component that introduces the user a contact form.
 */
(function () {
    'use strict';

    var itxContactForm = {
        controller: itxContactFormCtrl,
        templateUrl: 'contact-form.component.html'
    };

    itxContactFormCtrl.$inject = [
        'ngDialog',
        'ItxErrorMessagesFct',
        'ItxLoaderFct',
        'ItxTranslateSvc',
        'ItxContactSvc',
        'CountryService',
        'DUTTI_CONS',
        '$scope', 
        'acceptanceService'
    ];

    function itxContactFormCtrl(
        ngDialog,
        ItxErrorMessagesFct,
        ItxLoaderFct,
        ItxTranslateSvc,
        ItxContactSvc,
        CountryService,
        DUTTI_CONS,
        $scope,
        acceptanceService
    ) {
        var _this = this;

        _this.countries = null;

        _this.$onInit = function () {
            // Obtenemos el listado de paises
            CountryService.getCountries()
                .then(function (countries) {
                    _this.countries = countries;
                    _this.isWW = CountryService.isWWCountry();
                })
                .catch(function (error) {
                    ItxErrorMessagesFct.dialog(error.errorMessage);
                });

            _this.country = inditex.iStoreJSON.countryCode;

            _this.contactForm = {};
            _this.contactModel = {
                country: inditex.iStoreJSON.countryCode,
                middleName: '',
                phones: [{ countryCode: '', subscriberNumber: '' }]
            };
            _this.hasMiddleName = inditex.iStoreJSON.details.isMiddleName;
            _this.phoneCountry = { countryCode: '', phonePrefix: ' ', countryName: '' };

            if (!_this.contactModel.prefix) {
                _this.contactModel.prefix = inditex.iStoreJSON.details.phoneCountryCode;
            }

            _this.contactModel.type = 0;

            _this.isEmailTextShown = CountryService.is(DUTTI_CONS.country.KR);
        };

        _this.updateTopics = function (store) {
            _this.contactModel.type = store.id;
            _this.contactModel.storeType = store.type;
        };

        _this.getPhoneErrorMessage = function () {
            if (!_this.phoneCountry.countryCode || _this.phoneCountry.countryCode.length < 2) {
                return ItxTranslateSvc.translateCms('legacy.Messages_phone');
            }
            var digits = joyr.validation.phoneMaxDigits[_this.phoneCountry.countryCode];
            if (!digits) {
                return ItxTranslateSvc.translateCms('legacy.Messages_phone');
            } else {
                return ItxTranslateSvc.translate('Messages_phone_Digits', digits);
            }
        };
        /**
         * Sends a contact form to the online store e-mail.
         * @param {Object} contactData - The contents of the contact form.
         */
        _this.contact = function () {
            _this.contactForm.$setSubmitted();

            if (_this.contactForm.$invalid) {
                return;
            }

            ItxLoaderFct.show();

            ItxContactSvc.sendContactForm(_this.contactModel)
                .then(function () {
                    if( _this.isChina() ){
                        acceptanceService.consent( 'REGISTRO', ["transferenciaforzosa", "datossensibles"], _this.contactModel.email );
                    }
                    ngDialog.close();

                    ngDialog.open({
                        template: 'dialog-success.template.html',
                        className:
                            'new-modal ma-modal-sm ma-modal-macro ngdialog-theme-plain ngdialog-order-cancel-confirmation',
                        showClose: true,
                        data: {
                            title: _.capitalize(
                                ItxTranslateSvc.translateCms('legacy.ItxContactPopup.contact_form')
                            ),
                            message: ItxTranslateSvc.translateCms('legacy.ItxContactPopup.form_sent_success')
                        }
                    });
                })
                .catch(function (error) {
                    ItxErrorMessagesFct.dialog(error.errorMessage);
                })
                .finally(function () {
                    ItxLoaderFct.hide();
                });
        };

        _this.isSendEnabled = function() {
            if( _this.isChina() ){
                return !(_this.contactModel.sensitive_data && _this.contactModel.transfer_data);
            }else{
                return !_this.contactForm.$valid;
            }
        }

        _this.isChina = function(){
            return inditex.iCountryCode === 'CN';
        }
    }

    angular.module('itxApp.common').component('itxContactForm', itxContactForm);
})();
